import { debounce } from 'vue-debounce';
import Api from '@/service/api';
import * as restorePasswordHelper from '@/helpers/restore-password';

import Input from '@/components/Form/Input/index.vue';
import CodeField from '@/components/Form/CodeField/index.vue';
import MultiloginInput from '@/components/Form/MultiloginInput/index.vue';


export default {
  name: 'PasswordRestoration',

  components: {
    MultiloginInput,
    CodeField,
    Input,
  },

  computed: {
    expirationTime() {
      let minutes = Math.floor((this.expirationSeconds) / 60);
      let seconds = this.expirationSeconds - (minutes * 60);

      if (minutes < 10) minutes = `0${minutes}`;
      if (seconds < 10) seconds = `0${seconds}`;

      return `${minutes}:${seconds}`;
    },
  },

  methods: {
    async onCodeRequest() {
      if (!this.validate()) {
        return;
      }

      let response = null;

      this.loginType = this.$refs.multiLogin.getType();
      let queryType = null;

      if (this.loginType === 'phone') {
        queryType = 'sms-code';
      } else if (this.loginType === 'email') {
        queryType = 'get-restoration-code';
      } else {
        return;
      }

      this.isCanCodeRequest = false;
      try {
        response = await Api.post({
          url: `password-restoration/${queryType}`,
          data: { login: this.login },
        });
      } catch (error) {
        this.isCanCodeRequest = true;
        this.isError = true;
        this.errorCode = error.code;

        return;
      }

      this.isError = false;
      this.isCodeWaiting = true;
      this.isCanCodeRequest = true;

      restorePasswordHelper.saveExpirationTime({ login: this.login, time: response.data.time });

      this.checkExpirationTime();
    },

    async checkCode(code) {
      this.loginType = this.$refs.multiLogin.getType();
      let queryType = null;
      let codeType = null;

      if (this.loginType === 'phone') {
        queryType = 'recognize-user';
        codeType = 'sms_code';
      } else if (this.loginType === 'email') {
        queryType = 'recognize-user-by-code';
        codeType = 'code';
      } else {
        return;
      }

      try {
        const data = {
          login: this.login,
        };

        data[codeType] = code;

        await Api.post({
          url: `password-restoration/${queryType}`,
          data,
        });
      } catch (error) {
        this.isError = true;
        this.errorCode = error.code;
        return;
      }

      this.isSuccess = true;
      this.isError = false;
      this.$refs.code.success();

      restorePasswordHelper.saveCode(code);
      restorePasswordHelper.saveType(codeType);

      debounce(() => { this.$router.push('/password/change'); }, 1500)();
    },

    onChangeCode() {
      this.isError = false;
      this.errorCode = null;
    },

    validate() {
      if (!this.$refs.multiLogin.validate()) {
        this.validated = false;
      }

      return this.validated;
    },

    fieldsChanged(value) {
      this.validated = true;
      this.isError = false;

      if (this.isCodeWaiting && this.login !== value) {
        this.isSuccess = false;
        this.isCodeWaiting = false;
        this.code = null;
      }
    },

    checkExpirationTime(isOnFirst = false) {
      const localData = restorePasswordHelper.getLast();
      this.expirationSeconds = restorePasswordHelper.getExpirationSeconds(new Date(localData.time));

      if (this.expirationSeconds <= 0) {
        if (isOnFirst) {
          restorePasswordHelper.clearData();
          this.login = null;
        }

        this.isSuccess = false;
        this.isCodeWaiting = false;
        return;
      }

      this.setTimer();
    },

    setTimer() {
      const localTimerId = setInterval(
        () => {
          this.expirationSeconds -= 1;

          if (this.expirationSeconds <= 0) {
            this.expirationSeconds = 0;
            clearInterval(localTimerId);
          }
        },
        1000,
      );
    },
  },

  created() {
    const localData = restorePasswordHelper.getLast();

    if (localData) {
      this.isCodeWaiting = true;
      this.login = localData.login;
      this.checkExpirationTime(true);

      this.code = restorePasswordHelper.getCode();
      if (this.code) {
        this.isSuccess = true;
        debounce(() => { this.$router.push('/password/change'); }, 1500)();
      }
    }
  },

  data() {
    return {
      login: null,
      code: null,
      errorCode: null,
      validated: this.validated || true,
      isError: false,
      isCodeWaiting: false,
      isCanCodeRequest: true,
      isSuccess: false,
      expirationSeconds: 0,
      loginType: this.loginType,
    };
  },
};
